import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { DateNavigationOptions, DateNavigationType, SelectedDateClass } from '../../shared/date-navigation/date-navigation.component';
import { FinancialService } from '../financial.service';

type ContractItem = {
    contractId: string;
    projectId: string;
    projectTitle: string;
    contractSource: string;
    contractLabel: string;
    effectiveFrom: string | null;
    effectiveTo: string | null;
};

type MonthlyContracts = {
    month: number;
    contracts: ContractItem[];
};

type ProjectWithoutContract = {
    projectId: string;
    projectTitle: string;
};

type DivisionContracts = {
    divisionKey: string;
    divisionLabel: string;
    months: MonthlyContracts[];
    projectsWithoutContracts: ProjectWithoutContract[];
};

type ContractsOverviewResponse = {
    year: number;
    divisions: DivisionContracts[];
};

@Component({
    selector: 'app-contracts-overview',
    templateUrl: './contracts-overview.component.html',
    styleUrls: ['./contracts-overview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ContractsOverviewComponent implements OnInit, OnDestroy {
    loading = false;
    report: ContractsOverviewResponse | null = null;

    dateNavigationOptions: DateNavigationOptions = {
        selectedDate: new Date(),
        dateNavigationType: DateNavigationType.YEAR,
        selectedDateClass: SelectedDateClass.SMALL,
    };

    monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    private subscriptions = new Subscription();

    constructor(private financialService: FinancialService) {}

    ngOnInit(): void {
        this.fetchData();
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    updateSelectedDate(): void {
        this.fetchData();
    }

    getMonthLabel(month: number): string {
        return this.monthNames[month - 1] || String(month);
    }

    private fetchData(): void {
        const year = this.dateNavigationOptions.selectedDate.getFullYear();
        this.loading = true;

        this.subscriptions.add(
            this.financialService.getContractsMonthlyOverview(year).subscribe({
                next: (report) => {
                    this.report = report;
                    this.loading = false;
                },
                error: () => {
                    this.report = { year, divisions: [] };
                    this.loading = false;
                },
            }),
        );
    }
}
